import { render, staticRenderFns } from "./TruckRemove.vue?vue&type=template&id=54e5cccd&scoped=true"
import script from "./TruckRemove.vue?vue&type=script&lang=js"
export * from "./TruckRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5cccd",
  null
  
)

export default component.exports